import { Location } from '@angular/common';
import { Component, Host, inject, Input, OnInit, Optional, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { BrokerService } from 'src/app/core/services/broker.service';
import { DataLayersService } from 'src/app/core/services/data-layers.service';
import { FeatureFlagsService } from 'src/app/core/services/feature-flags.service';
import { LoadService } from 'src/app/core/services/load.service';
import { OfferDetailViewService } from 'src/app/core/services/offer-detail-view.service';
import { OfferService } from 'src/app/core/services/offer.service';
import { SesionService } from 'src/app/core/services/sesion.service';
import { HomeComponent } from 'src/app/pages/home/home.component';
import { environment } from 'src/environments/environment';
import { AppliedOfferListItem, OfferViewModel } from 'src/app/core/models/offer-view.model';
import { OfferRatingSubmit } from '../ui/molecules/offer-rating-molecule/offer-rating-molecule.component';
 
declare var $: any;
 
@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CardComponent {
 
  @Input() data!: OfferViewModel | AppliedOfferListItem;
  @Input() type: any = 'normal';
  @Input() index: any = 0;
  public urlLogin = environment.urlLogin;
  public cellphone: string | null;
  public btn_retomar_aplicacion = false;
  public ratingResultState: 'none' | 'ok' | 'error' = 'none';
  public id = '';
  public cardForTC = false;
  public textScore = '';
  public featureFlags: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly location = inject(Location);
  private readonly offerDetailView = inject(OfferDetailViewService);
  // Evita que un doble-click dispare validateSoftFilters() dos veces y deje el modal en blanco.
  private applyOfferInFlight = false;
  protected get offerData(): OfferViewModel { return this.data as OfferViewModel; }
  protected get appliedData(): AppliedOfferListItem { return this.data as AppliedOfferListItem; }
  constructor(
      private dataLayerService: DataLayersService, 
      public sesion: SesionService, 
      private activateRoute: ActivatedRoute,
      public load: LoadService, 
      public broker: BrokerService, 
      public cookieService: CookieService, 
      private readonly offerService: OfferService, 
      private readonly router: Router,
    @Optional() @Host() private readonly home: HomeComponent) {
    this.cellphone = localStorage.getItem('userPhone');
  }
 
  /**
   * Metodo de inicio del componente se genera un id para la tarjeta, se valida si la tarjeta es generica o Tarjeta de credito para que tome su respectiva configuracion
   * llama a la funcion setTextScore() y scoreProbability() para que en los detalles de la tarjeta muestre el score adecuado.
   */
  private _viewCardEventSent = false;
 
  ngOnInit(): void {
    if (this.type == 'normal' || this.type == 'nueva') {
      this.id = (this.offerData.company.id ?? '') + this.offerData.offerId;
      let isTC = (this.offerData.detail?.subcategories ?? []).filter((ele: any) => ele == 'TC')
      if (isTC.length > 0) {
        this.cardForTC = true;
      }
 
      // view_card_offer: una sola vez por tarjeta Bancolombia
      if (!this._viewCardEventSent && this.offerData.company?.id === '890903938') {
        this._viewCardEventSent = true;
        this.dataLayerService.dl_eventoGA4_view_card(
          this.offerData.card.productName,
          String(this.offerData.offerId),
          this.offerData.company.name,
          DataLayersService.getOfferIsFeatured(this.offerData.labelType),
          DataLayersService.getOfferLabel(this.offerData.labelType, this.offerData.textLabel)
        );
      }
    }
  }
 
  /**
   * Funcion que consume el servicio de datalayer y valida si la oferta es gratuita lo redirecciona a la pagina del aliado configurada, si no es gratuita valida si el usuario tinene sesion
   * si la tiene sesion abre el modal de confirmacion y si no guarda unos valores en el localstorage y lo redirecciona al sso
   */
  applyOffer() {
    localStorage.setItem('companyId', this.offerData.company.id ?? '');
    localStorage.setItem('offerId', String(this.offerData.offerId));
    localStorage.setItem('companyName', this.offerData.company.name);
    localStorage.setItem('productName', this.offerData.card.productName);
    this.offerService.offerSelected = this.offerData;
    // GA4 - evento data layer select_content que envía la información de la oferta seleccionada
    this.dataLayerService.dl_eventoGA4_content(
      'select_content',
      this.offerData.card.productName,
      String(this.offerData.offerId),
      this.offerData.company.name,
      DataLayersService.getOfferIsFeatured(this.offerData.labelType),
      DataLayersService.getOfferLabel(this.offerData.labelType, this.offerData.textLabel)
    );
    if (this.offerData.free == true) {
      let url = this.offerData.detail.urlRedirect ?? '';
      if (url.includes("https://") || url.includes("http://")) {
        window.location.href = url;
      } else {
        window.location.href = 'https://' + url;
      }
    } else {
      if (this.sesion.isIdsession()) {
        let name = this.offerData.company.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        let productName = this.offerData.card.productName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        this.dataLayerService.dl_eventoGA4_event_button('clic_modal_oferta', name + '-' + productName);
        if (this.offerData.card.buttonId != undefined && !this.applyOfferInFlight) {
          this.applyOfferInFlight = true;
          this.offerService.validateSoftFilters();
          setTimeout(() => { this.applyOfferInFlight = false; }, 1500);
        }
 
      } else {
        var cat: any = this.activateRoute.snapshot.paramMap.get('category');
        var subCat: any = this.activateRoute.snapshot.paramMap.get('subCategory');
        if (this.activateRoute.snapshot.paramMap.get('category') != null && this.activateRoute.snapshot.paramMap.get('subCategory') != null) {
          localStorage.setItem('url', '/' + cat + '/' + subCat);
        } else if (this.activateRoute.snapshot.paramMap.get('category') != null) {
          localStorage.setItem('url', '/' + cat);
        }
        window.location.href = this.urlLogin;
      }
    }
  }
 
  /**
   * "Ver más detalles": abre app-offer-detail-view en una pestaña nueva del navegador. La oferta se deja en el
   * traspaso (localStorage) para que la pestaña nueva muestre la misma información de la card.
   * Si el navegador bloquea la pestaña nueva (popup bloqueado, WebView), abre el detalle en la misma pestaña.
   */
  openOfferDetail() {
    const urlTree = this.router.createUrlTree([
      '/aliado',
      String(this.offerData.company.id ?? ''),
      String(this.offerData.offerId),
      'detalle'
    ]);

    this.offerDetailView.save(this.offerData);

    const newTab = window.open(this.location.prepareExternalUrl(this.router.serializeUrl(urlTree)), '_blank');
    if (newTab) {
      newTab.opener = null;
    } else {
      this.router.navigateByUrl(urlTree);
    }
  }

  /**
   * Funcion que dependiendo del aliado consume el servicio de /applyOffer 0 /davivienda, si llama a /applyOffer y el consumo es exitoso redirecciona
   * a la pagina que responde el servicio
   */
  redirect() {
    this.btn_retomar_aplicacion = true;
    this.enviar_dl(this.offerData);
    let isConectaFlow = true;
    if (this.offerData.settings.conecta) {
      this.continueApply();
    }
    else {
      const body = {
        idSession: this.cookieService.get('IDSESSIONMDC'),
        cellPhone: this.cellphone,
        country: "CO"
      }
      let dataOferta = {
        idSession: this.sesion.sesionCookie,
        companyId: this.offerData.company.id,
        offerId: this.offerData.offerId
      }
      if (this.offerData.company.id == "860034313") {
        let dataOfertaDav = {
          idSession: this.sesion.sesionCookie,
          userAgent: "",
          idDevice: ""
        }
        this.broker.aplicarOfertaDav(dataOfertaDav).subscribe((resultado: any) => {
          if (resultado.body.includes("http")) {
            this.open_offer_page(encodeURI(resultado.body));
          } else {
            this.router.navigate(['/error']);
          }
        });
      }
      else {
        this.broker.aplicarOferta(dataOferta).subscribe({
          next: (resultado: any) => {
            if (resultado.orderNumber) {
              this.offerService.offerApplied = resultado;
              this.offerService.offerSelected.isApplied = true;
              const urlRedirect = resultado.applyDetail.urlRedirect;
              const urlEncriptedData = resultado.applyDetail.urlEncriptedData;
              if (urlRedirect != "" || urlRedirect != undefined) {
                let urlRedirect = resultado.applyDetail.urlRedirect;
 
                // Solo para aliado Credissimo
                if (this.offerData.company.id == "901146443") {
                  this.open_offer_page(urlRedirect + '?bon=' + resultado.orderNumber);
                }
                // Solo para aliado Solventa
                else if (this.offerData.company.id == "901255144") {
                  this.broker.sendEncriptedData(body, urlEncriptedData + resultado.encryptedInfo);
                  this.open_offer_page(urlRedirect);
                }
                // Para todos
                else {
                  if (this.hasQueryString(urlRedirect)) {
                    urlRedirect = urlRedirect + '&lead=' + encodeURIComponent(resultado.encryptedInfo);
                  }
                  else {
                    urlRedirect = urlRedirect + '?lead=' + encodeURIComponent(resultado.encryptedInfo);
                  }
                  this.offerData.preselecta.urlRedirect = urlRedirect;
                  this.open_offer_page(urlRedirect);
                }
              }
            } else {
              this.errorService();
            }
          },
          error: error => {
            this.errorService();
          }
        });
      }
    }
  }
 
  // Esté método abre la página del aliado cuando el usuario retoma la aplicación
  open_offer_page(url: string) {
    setTimeout(() => {
      if (this.offerData.company.id == "901371820" || this.offerData.company.id == "901455665" || this.offerData.company.id == "901255144") {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
      setTimeout(() => {
        this.btn_retomar_aplicacion = false;
      }, 2500);
    }, 5000);
  }
 
  /**
   * Funcion que redirecciona a la pagia del alidado que este en la variable preselecta.urlRedirect,
   */
  continueApply() {
    let typeRedirect = '_self';
    if (this.offerData.company.id == "901371820" || this.offerData.company.id == "901455665" || this.offerData.company.id == "901255144") {
      typeRedirect = '_blank';
    }
    if (this.offerData.preselecta.urlRedirect != undefined) {
      if (this.offerData.preselecta.urlRedirect.includes("http")) {
        window.open(this.offerData.preselecta.urlRedirect, typeRedirect);
      } else {
        window.open(encodeURI(this.offerData.preselecta.urlRedirect), typeRedirect);
      }
    } else {
      window.open(encodeURI(this.offerData.urlRedirect), typeRedirect);
    }
  }
 
  /**
   * Funcion que cierra modal de error y redirecciona a pagina de error general
   */
  errorService() {
    this.offerService.errorApply = false;
    this.sesion.semiValid = false;
    this.load.close("#confirmationModalV2");
    this.router.navigate(['/error']);
  }
 
  /**
   * Funcion para validar si una url contiene querystring
   * @param url url a verificar
   * @returns si la url tiene formato con queryString
   */
  hasQueryString(url: any) {
    let reg = new RegExp('[?&][a-zA-Z]', 'g');
    let queryString = reg.exec(url);
    if (queryString != null) {
      return queryString.length > 0 ? true : false;
    }
    return false;
  }
 
  /**
   * Este evento enviará un data layer sobre la continuación de la aplicación "continue_application"
   * @param data_oferta información de la oferta
   */
  enviar_dl(data_oferta: any) {
    this.dataLayerService.dl_eventoGA4_content(
      'continue_application',
      data_oferta.card.productName,
      String(data_oferta.offerId),
      data_oferta.company.name,
      DataLayersService.getOfferIsFeatured(data_oferta.labelType),
      DataLayersService.getOfferLabel(data_oferta.labelType, data_oferta.textLabel)
    );
  }
 
  /**
   * Funcion para inicializar el objeto preselecta vacio
   */
  clearDataPreselecta() {
    this.offerData.preselecta = {};
  }
 
  /**
   * Funcion para abrir el formularion de calificacion de las tarjetas que estan en mis aplicaciones
   */
  openCali() {
    // this.load.open('#comments', '', '', false, undefined);
    $("#c-apli" + this.index).hide();
    $("#c-calif" + this.index).fadeIn();
  }
  /**
   * Funcion para cerrar el formularion de calificacion de las tarjetas que estan en mis aplicaciones
  */
  closeCali() {
    $("#c-calif" + this.index).hide();
    $("#c-apli" + this.index).fadeIn();
  }
 
  /**
   * Funcion que llama al servicio de /experienceEvaluation para enviar la informacion del formulario de la tarjeta que se encuentra en mis aplicaciones
   * Además envía la calificación y la información del aliado mediante un data layer identificado como send_feedback
   */
  sendOfferCali(ratingSubmit: OfferRatingSubmit) {
    let offerCali = {
      idSession: this.cookieService.get('IDSESSIONMDC'),
      orderNumber: this.appliedData.orderNumber,
      companyName: this.appliedData.companyName,
      productName: this.appliedData.productName,
      applyDate: new Date(this.appliedData.applyDate),
      applyState: this.appliedData.status,
      ratingOffer: ratingSubmit.rating,
      comments: ratingSubmit.comments,
      contacted: ratingSubmit.contacted
    }
 
    //GA4 - send_feedback
    this.dataLayerService.dl_eventoGA4_content(
      'send_feedback',
      this.appliedData.productName,
      String(this.appliedData.offersId),
      this.appliedData.companyName
    );
 
    this.broker.setExperienceEvaluation(offerCali).subscribe((result: any) => {
      if (result.code == "0") {
        $("#alerta-ok-" + this.index).show();
        this.closeCali();
      } else {
        $("#alerta-nok-" + this.index).show();
        this.closeCali();
      }
    }, error => {
      $("#alerta-nok-" + this.index).show();
      this.closeCali();
    });
  }
 
  irUrlOferta() {
    if (this.home) {
      let name = this.offerData.company.name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      let productName = this.offerData.card.productName.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      this.dataLayerService.dl_eventoGA4_event_button('clic_home_oferta-destacada', name + '-' + productName);
    }
 
    this.dataLayerService.dl_eventoGA4_content(
      'clic_view_offer',
      this.offerData.card.productName,
      String(this.offerData.offerId),
      this.offerData.company.name,
      DataLayersService.getOfferIsFeatured(this.offerData.labelType),
      DataLayersService.getOfferLabel(this.offerData.labelType, this.offerData.textLabel)
    );
 
    localStorage.setItem('companyId', this.offerData.company.id ?? '');
    localStorage.setItem('offerId', String(this.offerData.offerId));
    localStorage.setItem('companyName', this.offerData.company.name);
    localStorage.setItem('productName', this.offerData.card.productName);
    localStorage.setItem('landingByOffer', '1');
    localStorage.setItem('isHome', '1');
 
    window.location.href = this.urlLogin;
  }
 
  public showCardByCompanyId(companyId?: string): boolean {
    const flagByCompanyId: Record<string, string> = {
      "901780224": "showCredit365",
      "890903938": "showBancolombia"
    };
    if (!companyId) {
      return true;
    }
    const flagName = flagByCompanyId[companyId];
    return flagName ? this.featureFlags.isEnabled(flagName) : true;
  }
}